<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-text-field
          readonly
          v-if="client"
          :label="getCompanyLabels.client"
          v-model="client.name"
        ></v-text-field>
        <SelectClient
          v-else
          @client-selected="getNewClient"
          @new-client-created="getNewClient"
        ></SelectClient>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="isMobile ? 12 : 6">
        <v-text-field
          :label="getCompanyLabels.matter + ' Title'"
          v-model="caseObj.caseTitle"
        ></v-text-field>
      </v-col>

      <v-col :cols="isMobile ? 12 : 6">
        <v-text-field
          :label="getCompanyLabels.matter + ' Number'"
          v-model="caseObj.fileNumber"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col :cols="isMobile ? 12 : 6">
        <v-text-field
          label="Applicant / Petitioner [Optional]"
          v-model="caseObj.casePetitioner"
        ></v-text-field>
      </v-col>

      <v-col :cols="isMobile ? 12 : 6">
        <v-text-field
          label="Respondent [Optional]"
          v-model="caseObj.caseRespondent"
        ></v-text-field>
      </v-col>

      <v-col :cols="isMobile ? 12 : 6">
        <v-textarea
          label="Details / Description [Optional]"
          v-model="caseObj.caseDescription"
          rows="3"
        ></v-textarea>
      </v-col>

      <v-col :cols="isMobile ? 12 : 6">
        <v-textarea
          label="Notes [Optional]"
          v-model="caseObj.notes"
          rows="3"
        ></v-textarea>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4"> </v-col>
      <v-col cols="4">
        <v-btn
          dark
          color="teal"
          rounded
          large
          class="mx-auto"
          @click="addCase()"
          v-if="client && caseObj.fileNumber && caseObj.caseTitle"
        >
          Submit
        </v-btn>
      </v-col>
      <v-col cols="4"> </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";
import SelectClient from "@/components/Clients/SelectClient.vue";

export default {
  props: ["client"],
  components: { SelectClient },
  mounted() {
    if (this.client) {
      this.caseObj.selectedClientID = this.client.id_number;
    }
  },
  watch: {
    client(newVal) {
      this.caseObj.selectedClientID = newVal.id_number;
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
  },
  data() {
    return {
      caseObj: {
        caseTitle: null,
        selectedClientID: null,
        caseDescription: null,
        notes: null,
        casePetitioner: null,
        caseRespondent: null,
        fileNumber: null,
      },
      selectedClient: null,
    };
  },
  methods: {
    addCase() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken("/auth/add-case", this.caseObj, this.getAccessToken)
        .then((caseObj) => {
          this.$emit("case-added", caseObj);
          this.$store.commit("setLoader", false);
        });
    },
    getNewClient(client) {
      this.client = client;
    },
    closeCaseDialog() {
      this.$emit("close-case-dialog");
    },
    selectedClientField(vals) {
      this.caseObj.selectedClientID = vals[0];
      this.selectedClient = vals[1];
    },
  },
};
</script>

<style></style>
